// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { Page } from '@roc/feature-app-core';
import { getPlatformLoanRoutesConfig, useLoanRoutes } from '@roc/feature-loans-routes-config';
import { observer } from 'mobx-react';
import { Redirect, Route, Switch, useHistory, useLocation, useParams } from 'react-router';
import { useRoutes } from '../hooks';
import { Box } from '@material-ui/core';
import React, { useEffect } from 'react';
import {
  editLoanRouteByLoanSubType,
  useThirdPartyLoanRoutes,
} from '@roc/feature-third-party-loans';
import { useOneToolRoutes, routeByLoanSubType } from '@roc/feature-one-tool';

export const PlatformLoanMainView = observer(() => {
  const { platformLoanRoutesConfig } = useRoutes();
  const { thirdPartyLoanRoutesConfig } = useThirdPartyLoanRoutes();
  const { oneToolRoutesConfig } = useOneToolRoutes();
  const { loanRoutesConfig } = useLoanRoutes();
  const { loanNumber } = useParams<{ loanNumber: string }>();
  const platformUiRef1 = React.useRef<HTMLElement>(null);
  const platformUiRef2 = React.useRef<HTMLElement>(null);
  const { replace, push } = useHistory();
  const { pathname } = useLocation();

  const onTabChange = (payload) => {
    replace(
      platformLoanRoutesConfig.loans(loanNumber).children[payload.tab].url
    );
  }

  const onEditLoan = (payload) => {
    const loanType = payload?.loanType;
    const route =
      thirdPartyLoanRoutesConfig[editLoanRouteByLoanSubType[loanType]];
    if (route) {
      push(route(payload?.loanNumber).url);
    }
  }

  const onEditPlatformCapitalQuote = (payload) => {
    const loanType = payload?.loanType;
    const route =
      oneToolRoutesConfig[routeByLoanSubType[loanType]];
    if (route) {
      push(route(payload?.quoteId).url);
    }
  }

  const onPlatformProviderLoanToDos = (payload) => {
    const route = loanRoutesConfig.loans;
    if (route) {
      push(route(payload?.loanNumber).children.dashboard.url);
    }
  }

  const eventActions = {
    'onTabChange': onTabChange,
    'onLoanEdit': onEditLoan,
    'onPlatformProviderLoanToDos': onPlatformProviderLoanToDos,
    'onEditPlatformCapitalQuote': onEditPlatformCapitalQuote,
  };

  useEffect(() => {
    const handler = (e: CustomEvent) => {
      const { eventName, payload } = e.detail;
      const action = eventActions[eventName];
      if (action) {
        action(payload);
      }
    };
    const node1 = platformUiRef1.current;
    const node2 = platformUiRef2.current;
    node1?.addEventListener('platform-ui-event', handler);
    node2?.addEventListener('platform-ui-event', handler);
    return () => {
      node1?.removeEventListener('platform-ui-event', handler);
      node2?.removeEventListener('platform-ui-event', handler);
    };
  }, [loanNumber, pathname]);

  return (
    <Box width={'100%'} height={'100%'}>
      <Switch>
        <Route
          exact
          path={
            platformLoanRoutesConfig.loans(loanNumber).children.dashboard.path
          }
        >
          <Page
            routeDefinition={
              platformLoanRoutesConfig.loans(loanNumber).children.dashboard
            }
          >
            <platform-ui
              id="platform-ui-loan-view-summary"
              component="loan_view"
              data-loan-number={loanNumber}
              data-active-tab="dashboard"
              ref={platformUiRef1}
            />
          </Page>
        </Route>
        <Route
          exact
          path={platformLoanRoutesConfig.loans(loanNumber).children.tasks.path}
        >
          <Page
            routeDefinition={
              platformLoanRoutesConfig.loans(loanNumber).children.tasks
            }
          >
            <platform-ui
              id="platform-ui-loan-view-tasks"
              component="loan_view"
              data-loan-number={loanNumber}
              data-active-tab="tasks"
              ref={platformUiRef2}
            />
          </Page>
        </Route>
        <Route
          exact
          path={`${platformLoanRoutesConfig.loans(loanNumber).path}/`}
          render={() => (
            <Redirect
              to={
                platformLoanRoutesConfig.loans(loanNumber).children.dashboard
                  .url
              }
            />
          )}
        />
      </Switch>
    </Box>
  );
});

export const getPlatformLoanRoutes = (basePath: string, baseUrl: string) => {
  const platformConfig = getPlatformLoanRoutesConfig(basePath, baseUrl);
  return {
    loanDetails: (
      <Route path={platformConfig.loans().path}>
        <PlatformLoanMainView />
      </Route>
    ),
  };
};
